import { EbayAspect } from "types/ebayMetadata";
import { camelCase, snakeCase } from "lodash";
import { useState } from "react";
import { Autocomplete, TextField, Box } from "@mui/material";
import { ProductCatalog } from "types/productCatalog";

function EbayMultiAspectAutocomplete({ aspect, product }: { aspect: EbayAspect; product: ProductCatalog }) {
  const productValue = product.extraData?.[camelCase(aspect.localizedAspectName)] || "";
  const [values, setValues] = useState<string[] | undefined>(() => {
    if (productValue.trim().length === 0) return;

    return productValue.split("|");
  });
  const options = aspect.aspectValues?.map((v) => v.localizedValue) || [];
  return (
    <Box sx={{ position: "relative" }}>
      <Autocomplete
        freeSolo={aspect.aspectConstraint.aspectMode === "FREE_TEXT"}
        multiple
        disableCloseOnSelect
        disableClearable={true}
        options={options}
        value={values}
        onChange={(_, value) => {
          setValues(value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={aspect.localizedAspectName + `${aspect.aspectConstraint.aspectRequired ? " *" : ""}`}
            slotProps={{ input: { ...params.InputProps, type: "search" } }}
          />
        )}
      />
      {/*
         This input cannot be type=hidden because otherwise html5 required validation will not work.
         As a workaround, we position above the input and set opacity to 0.
      */}
      <input
        name={`extra_attributes[${snakeCase(aspect.localizedAspectName)}]`}
        type="text"
        style={{ opacity: 0, width: 0, position: "absolute", top: "50%", left: "50%", pointerEvents: "none" }}
        value={values?.join("|")}
        required={aspect.aspectConstraint.aspectRequired}
      />
    </Box>
  );
}

export function EbayAspectAutocomplete({ aspect, product }: { aspect: EbayAspect; product: ProductCatalog }) {
  const isMulti = aspect.aspectConstraint.itemToAspectCardinality === "MULTI";
  const options = aspect.aspectValues?.map((v) => v.localizedValue) || [];

  if (isMulti) {
    return <EbayMultiAspectAutocomplete aspect={aspect} product={product} />;
  } else {
    return (
      <Autocomplete
        freeSolo={aspect.aspectConstraint.aspectMode === "FREE_TEXT"}
        disableClearable={true}
        options={options}
        defaultValue={product.extraData?.[camelCase(aspect.localizedAspectName)]}
        renderInput={(params) => (
          <TextField
            {...params}
            name={`extra_attributes[${snakeCase(aspect.localizedAspectName)}]`}
            label={aspect.localizedAspectName}
            required={aspect.aspectConstraint.aspectRequired}
            slotProps={{ input: { ...params.InputProps, type: "search" } }}
          />
        )}
      />
    );
  }
}
